"use client";

import { MAX_MESSAGE_LENGTH } from "@/lib/box";

// The optional note we copy onto a card, sent as a "Gift message" line attribute.
export function GiftNote({ value, onChange }: { value: string; onChange: (value: string) => void }) {
  return (
    <details className="group mt-7 border-y border-paper/20 py-4">
      <summary className="flex list-none items-center justify-between text-[0.9375rem] [&::-webkit-details-marker]:hidden">
        <span>Add a handwritten note</span>
        <span className="text-paper group-open:hidden">Free</span>
      </summary>
      <label htmlFor="gift-note" className="sr-only">
        Your note
      </label>
      <textarea
        id="gift-note"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        maxLength={MAX_MESSAGE_LENGTH}
        rows={4}
        placeholder="Dear Jane, I saw this and thought of you."
        className="field mt-3 font-serif italic"
      />
      <p className="mt-1 text-right text-sm tabular-nums text-paper">
        {value.length} of {MAX_MESSAGE_LENGTH}
      </p>
    </details>
  );
}
